import React from "react"

import Layout from "../components/layout"
import Page from "../components/Page/page"
import VideoList from "../components/Video/list";

class Videos extends React.Component {
  render() {
    const { location } = this.props
    return (
      <Layout location={location}>
        <Page id="7" />
        <VideoList />
      </Layout>
    )
  }
}

export default Videos
